/**
 * Admin\CLI: API keys, Device Agent pairing, the menu report sync and the administration
 * read routes. Moved under `Admin` on 2026-10-12 (chore/security-path-reorg): `CLI` was a root
 * folder, `Reports\SyncMenu` sat at `Admin\Reports` and the three `Administration` commands at
 * `System\Administration`, which ships an Everyone Deny (`sd_SecurityEntry_AdministrationDeny.sql`)
 * that now sits on `Admin\CLI\Administration`.
 */

import { admin } from './admin';

export const cli = admin.folder('CLI');
export const administration = cli.folder('Administration');
export const administrationViewConnections = administration.command('ViewConnections');
export const administrationViewEffectivePermissions = administration.command('ViewEffectivePermissions');
export const administrationViewLoginHistory = administration.command('ViewLoginHistory');
export const apiKeys = cli.folder('API Keys');
export const apiKeysAdminCreate = apiKeys.command('Admin Create');
export const apiKeysCreate = apiKeys.command('Create');
export const apiKeysList = apiKeys.command('List');
export const apiKeysRevoke = apiKeys.command('Revoke');
export const apiKeysRotate = apiKeys.command('Rotate');
export const deviceAgent = cli.folder('Device Agent');
export const deviceAgentPair = deviceAgent.command('Pair');
export const reports = cli.folder('Reports');
export const reportsSyncMenu = reports.command('SyncMenu');
